import React, { Component } from "react";

let experience = [
  {
    position: "Software Developer",
    description: "Current position",
    img: ["Images/aa_logo.png***''"],
  },
  {
    position: "Goldman Sachs' 1st place winner",
    description: "2021",
    img: ["Images/hackDFW.svg***https://devpost.com/software/yodash"],
  },
  {
    position: "B.S. Computer Science Engineering",
    description: "2021",
    img: ["Images/uta_logo.png***''"],
  },
  {
    position: "Lab Assistant",
    description: "2020 - 2021",
    img: [
      "Images/MobiSec_logo.png***https://www.uta.edu/news/news-releases/2020/05/18/li-career",
      "Images/uta_logo.png***''",
    ],
  },
  {
    position: "Lab Assistant",
    description: "2020 - 2021",
    img: [
      "Images/IDIR_logo.png***https://idir.uta.edu/",
      "Images/uta_logo.png***''",
    ],
  },
  {
    position: "Software Developer",
    description: "2019 - 2021",
    img: ["Images/lyagency_logo.png***http://lyagency.com/"],
  },
];

class About extends Component {
  render() {
    return (
      <>
        <div
          id="about"
          style={{
            zIndex: "10",
            position: "fixed",
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={function (e) {
            if (e.target !== e.currentTarget) return;
            e.currentTarget.style.display = "none";
          }}
        >
          <div id="container" style={container} onClick={function (e) {}}>
            <img
              src="Icons/close.png"
              alt="Close Popup"
              style={{
                position: "absolute",
                top: "16px",
                right: "16px",
                width: "25px",
                height: "25px",
                cursor: "pointer",
              }}
              onClick={(event) => {
                document.getElementById("about").style.display = "none";
              }}
            />
            <h1>Meet Loon</h1>
            <h3>Powered by Google</h3>
            <p>
              I will move wherever you need me and collect real time data to
              improve wild fire detection and reduce response time!
              <a href='https://x.company/projects/loon/' target='_blank'> <i>read more</i></a>
            </p>
            <img
                src='/Images/Loon_diagram.jpg'
                alt="instruction gif"
                style={{
                  width: "50%",
                  marginBottom: "32px",
                  borderRadius: "5px",
                }}
              />
          </div>
        </div>
      </>
    );
  }
}

const container = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  position: "fixed",
  width: "auto",
  height: "auto",
  maxWidth: "75%",
  maxHeight: "80%",
  backgroundColor: "#FFF",
  padding: "0px 32px",
  borderRadius: "5px",
  boxShadow:
    "rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px",
  overflowY: "scroll",
  border: "2px solid #555",
};

const rowStyle = {
  height: "auto",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-around",
  flexWrap: "wrap",
  alignItems: "center",
  paddingBottom: "10px",
  borderBottom: "1px solid #86a7ba",
  marginBottom: "10px",
};

const posStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  width: "400px",
};

const imgStyle = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "center",
  width: "400px",
};

export default About;
